import { createAppSelector } from 'store/hooks';

export const onboardFlowSelector = createAppSelector(
  [(state) => state.setting.localDeviceSettings],
  (localDeviceSettings) => {
    return {
      localDeviceSettings
    };
  }
);

export const onboardFlowRoutineHabitsActionsSelector = createAppSelector(
  [
    (state) => state.setting.currentSettings,
    (state) => state.routineSuggestions.isInstallingRoutineSuggestions,
    (state) => state.routineSuggestions.routineSuggestions
  ],
  (currentSettings, isInstallingRoutineSuggestions, routineSuggestions) => {
    return {
      currentSettings,
      isInstallingRoutineSuggestions,
      routineSuggestions
    };
  }
);

export const onboardFlowRoutineTimeSetupSelector = createAppSelector(
  [
    (state) => state.setting.currentSettings.break_activities,
    (state) => state.routineSuggestions.isInstallingRoutineSuggestions
  ],
  (breakActivities, isInstallingRoutineSuggestions) => {
    return {
      breakActivities,
      isInstallingRoutineSuggestions
    };
  }
);

export const OnboardingFlowRoutineHabitsSelector = createAppSelector(
  [
    (state) => state.routineSuggestions.routineSuggestions,
    (state) => state.general.tabLayout.activeTab,
    (state) => state.routineSuggestions.showEditSuggestionsModal,
    (state) => state.modal.confirmAction.showConfirmModal
  ],
  (
    routineSuggestions,
    activeTabLayoutTabIndex,
    showEditSuggestionsModal,
    showConfirmModal
  ) => {
    return {
      routineSuggestions,
      activeTabLayoutTabIndex,
      showEditSuggestionsModal,
      showConfirmModal
    };
  }
);

export const OnboardingFlowChooseRoutinesSelector = createAppSelector(
  [
    (state) => state.routineSuggestions.isFetchingRoutineSuggestions,
    (state) => state.routineSuggestions.routineSuggestionPayload.routines,
    (state) => state.setting.language
  ],
  (isFetchingRoutineSuggestions, routinesPayload, language) => {
    return { isFetchingRoutineSuggestions, routinesPayload, language };
  }
);

export const OnboardingFlowRoutineSelector = createAppSelector(
  [(state) => state.routineSuggestions.isFetchingRoutineSuggestions],
  (isFetchingRoutineSuggestions) => {
    return isFetchingRoutineSuggestions;
  }
);

export const onboardingFlowGoalsSelectionsSelector = createAppSelector(
  [(state) => state.routineSuggestions.selectedGoals],
  (selectedGoals) => {
    return { selectedGoals };
  }
);

export const onboardFlowSignInSelector = createAppSelector(
  [(state) => state.setting.isNewUserSigninProcess],
  (isNewUserSigninProcess) => {
    return isNewUserSigninProcess;
  }
);

export const bearsonaProfileInfoActionsSelector = createAppSelector(
  [(state) => state.setting.isUpdatingDeviceSettings],
  (isUpdatingDeviceSettings) => {
    return isUpdatingDeviceSettings;
  }
);

export const onboardFlowCurrentSettingsSelector = createAppSelector(
  [(state) => state.setting.currentSettings],
  (currentSettings) => {
    return { currentSettings };
  }
);
